import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { Set } from 'immutable';
import cx from 'classnames';
import Spinner from 'design-system/Spinner';

import { Section } from './Section';
// TODO: Migrate module so that you don’t import from the corp project in a global module
/* eslint-disable restrict-imports/restrict-imports */
import Table from 'corp/components/UI/Table';
import TaskPill from 'corp/components/UI/ProductPill';
import _ from 'lodash';

const SelectCell = ({ type, selected, onClick }: $FIXME) => (
  <div onClick={onClick} className={cx('select-cell', { selected })}>
    <TaskPill type={type} showTitle={false} isWorker={true} disabled={!selected} />
    <style jsx>{`
      .select-cell {
        width: 24px;
        height: 24px;
        margin: 0 auto;
      }
    `}</style>
  </div>
);

const TaskList = ({ tasks, onChange, loading }: $FIXME) => {
  const [selection, setSelection] = useState(Set());
  const toggleSelect = useCallback(
    (id: any) => {
      selection.has(id) ? setSelection(selection.delete(id)) : setSelection(selection.add(id));
    },
    [selection],
  );

  const selectAll = useCallback(() => {
    setSelection(Set(tasks.map((task: $FIXME) => task.id)));
  }, [tasks]);

  const toggleSelectAll = useCallback(() => {
    selection.count() < tasks.length ? selectAll() : setSelection(Set());
  }, [selectAll, selection, tasks.length]);

  // Reset selection to all when new tasks
  useEffect(selectAll, [tasks]);

  // Update selected tasks.
  useEffect(() => {
    onChange(tasks.filter((task: $FIXME) => selection.has(task.id)));
  }, [onChange, selection, tasks]);

  const columns = useMemo(() => {
    let columns = [
      {
        width: 80,
        sortable: false,
        headerClassName: '-cursor-pointer',

        // eslint-disable-next-line react/display-name
        Header: () => <div onClick={toggleSelectAll}>Select all</div>,

        // eslint-disable-next-line react/display-name
        Cell: ({ original }: $FIXME) => (
          <SelectCell
            type={original.type}
            selected={selection.has(original.id)}
            onClick={() => toggleSelect(original.id)}
          />
        ),
      },
      { Header: 'Task ID', accessor: 'id', className: 'text-center' },
      { Header: 'Subtask Id', accessor: 'subtask_id', className: 'text-center' },
      { Header: 'Created at', accessor: 'created_at', className: 'text-center' },
      { Header: 'Completed at', accessor: 'completed_at', className: 'text-center' },
      { Header: 'Status', accessor: 'status', className: 'text-center text-uppercase' },
    ];
    const subtasksExist = _.some(tasks, task => task.subtask_id);
    if (!subtasksExist) {
      columns = columns.filter(column => column.accessor !== 'subtask_id');
    }
    return columns;
  }, [tasks, selection, toggleSelectAll, toggleSelect]);

  return (
    <div className="root">
      <Section name={`Select Tasks (${selection.count()}/${tasks.length})`}>
        {loading && <Spinner style={{ margin: '2em 0' }} />}
        {!loading && (
          <div className="task-list">
            <Table
              data={tasks}
              keyField="id"
              className="-highlight"
              defaultPageSize={10}
              noDataText="No tasks found."
              columns={columns}
              getTrProps={(state: $FIXME, rowInfo: $FIXME) => {
                return {
                  className: cx({
                    selected: rowInfo && selection.has(rowInfo.row.id),
                  }),
                };
              }}
            />
          </div>
        )}
      </Section>

      <style jsx>{`
        .root :global(.section-body) {
          padding: 0;
        }
      `}</style>
    </div>
  );
};

export default TaskList;
